import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Loading, Modal, Text } from '@reveni-io/reveni-ui'

import LineItemCustomsInfo from './LineItemCustomsInfo/LineItemCustomsInfo'
import * as Styles from './styles'

const EditCustomsInfoModal = ({
  items,
  onClose,
  show,
  loading,
  regions,
  onChange,
  onConfirm,
  generatingLabel,
  savingChanges,
}) => {
  const { t } = useTranslation()

  const isFormValid = () => {
    return items?.every(item => {
      return (
        item.customsInfo?.sku &&
        item.customsInfo?.country?.code &&
        item.customsInfo?.hs_code?.length > 5 &&
        item.customsInfo?.weight &&
        item.customsInfo?.weight_unit
      )
    })
  }

  return (
    <Modal show={show} onClose={onClose} title={t('Información de aduanas')} size="l">
      <Loading show={loading} height="350">
        <Styles.Container>
          <Text type="bodyMRegular">
            {t(
              'Completa la información de aduanas de los productos para que sea posible generar la etiqueta de devolución'
            )}
          </Text>
          {items?.map(item => (
            <LineItemCustomsInfo key={item.id} lineItem={item} regions={regions} onChange={onChange} />
          ))}
          <Styles.ActionsContainer>
            <Button onClick={onClose} variant="outlined" fullWidth>
              {t('Cancelar')}
            </Button>
            <ButtonWithSpinner
              fullWidth
              onClick={onConfirm}
              defaultLabel={t('Generar etiqueta')}
              loadingLabel={t('Generando etiqueta')}
              loading={generatingLabel}
              disabled={!isFormValid() || savingChanges || generatingLabel}
            />
          </Styles.ActionsContainer>
        </Styles.Container>
      </Loading>
    </Modal>
  )
}

export default EditCustomsInfoModal
